module.exports = __webpack_public_path__ + "static/img/ccjh.707efa0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/ccjh.png
// module id = sUN2
// module chunks = 0